import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Stack,
  Typography,
  Autocomplete,
  Paper,
} from '@mui/material';

const BulkActions = ({ onBulkAction, allTags }) => {
  const [tagInput, setTagInput] = useState('');
  const [commentInput, setCommentInput] = useState('');

  const handleAddTag = () => {
    if (tagInput.trim()) {
      onBulkAction('addTag', tagInput.trim());
      setTagInput('');
    }
  };

  const handleRemoveTag = () => {
    if (tagInput.trim()) {
      onBulkAction('removeTag', tagInput.trim());
      setTagInput('');
    }
  };

  const handleCommentSubmit = () => {
    if (commentInput.trim()) {
      onBulkAction('setComment', commentInput.trim());
      setCommentInput('');
    }
  };

  return (
    <Box sx={{ 
      mt: 2
    }}>
      <Typography variant="h6" gutterBottom>
        Bulk Actions
      </Typography>

      <Paper sx={{ p: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Autocomplete
            size="small"
            freeSolo
            clearOnEscape
            options={[...allTags].sort()}
            value={tagInput}
            onInputChange={(event, newValue) => {
              setTagInput(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Enter tag..."
                sx={{ minWidth: 200 }}
                size="small"
              />
            )}
          />
          <Button
            variant="outlined"
            onClick={handleAddTag}
            disabled={!tagInput.trim()}
          >
            Add Tag
          </Button>
          <Button
            variant="outlined"
            onClick={handleRemoveTag}
            disabled={!tagInput.trim()}
          >
            Remove Tag
          </Button>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => onBulkAction('tickTax')}
          >
            Tick Tax
          </Button>
          <Button
            variant="outlined"
            onClick={() => onBulkAction('untickTax')}
          >
            Untick tax
          </Button>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            label="Comments"
            size="small"
            value={commentInput}
            onChange={(e) => setCommentInput(e.target.value)}
            sx={{ minWidth: 180 }}
          />
          <Button
            variant="outlined"
            onClick={handleCommentSubmit}
            disabled={!commentInput.trim()}
          >
            Set Comment
          </Button>
          <Button
            variant="outlined"
            onClick={() => onBulkAction('clearComment')}
          >
            Clear Comment
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default BulkActions;



